/**
 * CAP Payment Integration Types
 * Based on CAP Payment Integration - Frontend Implementation Guide
 */

// Session Types
export interface ICreateSessionRequest {
  integer_tracking_id: string;
  crypto_currency?: string;
}

export interface ICustomerData {
  email?: string;
  firstName?: string;
  lastName?: string;
  country?: string;
  city?: string;
  state?: string;
  zip?: string;
  address?: string;
  allowMerchantPayment?: boolean;
}

export interface ICreateSessionResponse {
  session_id: string;
}

export interface ISessionData {
  session_id: string;
  user_id: string;
  payment_route_id: string;
  payment_route_meta?: {
    source_currency_id: string;
    target_currency_id: string;
  };
  customer: ICustomerData;
  checkout_data?: ICheckoutData;
  merchantFlowEnabled?: boolean;
  merchantFlowCompleted?: boolean;
  merchantWidgetDomain?: string;
  created_at: string;
  expires_at: string;
}

export interface ICheckoutData {
  amount: string;
  currency: string;
  integrity: string;
  checkout_id: string;
}

export interface IUpdateSessionRequest {
  crypto_currency?: string;
  customer?: Partial<ICustomerData>;
  checkout_data?: {
    amount?: number;
    currency?: string;
  };
  merchantFlowCompleted?: boolean;
}

export interface IUpdateSessionResponse {
  success: boolean;
  checkout_id: string;
}

// Checkout Types
export interface ICheckoutDataResponse {
  integrity: string;
  checkoutId: string;
  sessionId: string;
  amount: string;
  currency: string;
  crypto: string;
  cryptoAmount: string;
}

// Payment Types
export interface IPaymentData {
  payment_id: string;
  checkout_id: string;
  status: EPaymentStatus;
  result: IPaymentResult;
  amount: string;
  currency: string;
  payment_type: string;
  payment_brand?: string;
  timestamp: string;
  new_account_created?: boolean;
}

export interface IPaymentResult {
  code: string;
  description: string;
  message: string;
}

export enum EPaymentStatus {
  Pending = 'pending',
  Completed = 'completed',
  Processing = 'processing',
  Failed = 'failed',
}

// Google Pay Types
export interface IGooglePayConfig {
  gatewayMerchantId: string;
  merchantId: string;
  merchantName: string;
  allowedCountryCodes: string[];
  currency: string;
}

// Merchant Payment URL Types
export interface IMerchantPaymentUrlResponse {
  externalUrl: string;
}

// Estimate Payment Types
export interface IEstimatePaymentResponse {
  source_currency_id: string;
  target_currency_id: string;
  source_currency_amount: number;
  target_currency_amount: number;
  price: number;
  fee_currency_id: string;
  fee_currency_amount: number;
}

// Widget Message Types
export enum ECapWidgetMessageType {
  PaymentSuccess = 'CAP_PAYMENT_SUCCESS',
  PaymentError = 'CAP_PAYMENT_ERROR',
  PaymentPending = 'CAP_PAYMENT_PENDING',
  MerchantFlowCompleted = 'CAP_MERCHANT_FLOW_COMPLETED',
}

export interface ICapWidgetMessage {
  type: ECapWidgetMessageType;
  paymentId?: string;
  checkoutId?: string;
  status?: string;
  error?: string;
}

